import GettingStartedWrapper from './GettingStartedWrapper';

export default GettingStartedWrapper;
